export const formatRows = (listaItems) => 
  listaItems.map((item, index) => ({
    index: index + 1,
    id: item.oca_id || "Id no disponible",
    cli_codigo: item.cli_codigo|| "Codigo no disponible",
    razon_social: 
    item?.cli_id === 1
      ? "Consumidor Final"
      : item?.razon_social?.trim() ? item.razon_social : "Nombre No Disponible",
    cli_name: 
    item?.cli_id === 1
      ? "Consumidor Final"
      : item?.cli_name?.trim() ? item.cli_name : "",
    cli_direccion: item.cli_direccion|| "Direccion no disponible",
    createdAt: item.oca_mobile_creation_date || "Fecha de creación no disponible",
    sel_fullname: 
      item["cache-empl"]?.sel_lastname && item["cache-empl"]?.sel_firstname 
        ? `${item["cache-empl"]?.sel_lastname}, ${item["cache-empl"]?.sel_firstname}`
        : item["cache-empl"]?.sel_lastname || item["cache-empl"]?.sel_firstname || "Pagina Web",
    totalpedidodesc: item.monto_total_desc || "0",
    totalpedido: item.monto_total || "0",
    formapago: item.oca_pago_estado ?? "Forma de pago no disponible",
    cli_tel: item.cli_tel ?? null,
    oca_state:item.oca_state
  }));

